<div
  class="container-xl gx-0 gx-lg-5"
  *ngIf="collection?.products && collection.products.length != 0"
>
  <div class="collection-meta d-flex flex-column flex-lg-row pt-5 pb-5 d-flex">
    <div
      class="flex-grow-1 actions px-4 py-3 px-lg-0 d-flex flex-row align-items-center"
    >
      <h1 class="mb-0">{{ collection.title }}</h1>
    </div>
    <div
      class="filter-toggle my-3 my-lg-0 px-4 px-lg-0 flex-shrink-1 d-flex flex-row align-items-center"
    >
      <button
        (click)="toggleFilters()"
        class="toggle-filters btn btn-lg btn-outline-dark d-flex flex-row justify-content-between align-items-center"
      >
        Show Filters
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7507 8C13.0467 6.84985 14.0908 6 15.3333 6C16.5759 6 17.62 6.84985 17.916 8H19.3329C19.7013 8 20 8.29591 20 8.66667C20 9.03486 19.7017 9.33333 19.3329 9.33333H17.916C17.62 10.4835 16.5759 11.3333 15.3333 11.3333C14.0908 11.3333 13.0467 10.4835 12.7507 9.33333H4.66713C4.29868 9.33333 4 9.03742 4 8.66667C4 8.29848 4.29831 8 4.66713 8H12.7507ZM6.08401 14.6667C6.38004 13.5165 7.42411 12.6667 8.66667 12.6667C9.90923 12.6667 10.9533 13.5165 11.2493 14.6667H19.3329C19.7013 14.6667 20 14.9626 20 15.3333C20 15.7015 19.7017 16 19.3329 16H11.2493C10.9533 17.1502 9.90923 18 8.66667 18C7.42411 18 6.38004 17.1502 6.08401 16H4.66713C4.29868 16 4 15.7041 4 15.3333C4 14.9651 4.29831 14.6667 4.66713 14.6667H6.08401ZM8.66667 16.6667C9.40305 16.6667 10 16.0697 10 15.3333C10 14.597 9.40305 14 8.66667 14C7.93029 14 7.33333 14.597 7.33333 15.3333C7.33333 16.0697 7.93029 16.6667 8.66667 16.6667ZM15.3333 10C16.0697 10 16.6667 9.40305 16.6667 8.66667C16.6667 7.93029 16.0697 7.33333 15.3333 7.33333C14.597 7.33333 14 7.93029 14 8.66667C14 9.40305 14.597 10 15.3333 10Z"
            fill="black"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
@defer {

<div
  class="filters-bg"
  (click)="toggleFilters()"
  [ngClass]="{ show: _showFilters }"
></div>
<div class="filters" preventDefault [ngClass]="{ show: _showFilters }">
  <div class="d-flex mb-4 flex-row align-items-center justify-content-between">
    <h3 class="mb-0 lh-1">Filter & Sort</h3>
    <svg
      (click)="toggleFilters()"
      width="24"
      height="25"
      class="action"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="16.3032"
        y1="17.0962"
        x2="6.40369"
        y2="7.19674"
        stroke="black"
      />
      <line
        x1="16.5962"
        y1="7.19682"
        x2="6.69673"
        y2="17.0963"
        stroke="black"
      />
    </svg>
  </div>

  <ng-container *ngFor="let facet of facets; let last = last">
    <mercury-filter-accordion
      class="d-flex flex-column"
      [facet]="facet"
    ></mercury-filter-accordion>
    <hr *ngIf="!last" />
  </ng-container>
</div>

} @placeholder {
<div></div>
}

<div
  class="container-xl gx-0 gx-lg-3"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="300"
  (scrolled)="loadMore()"
  *ngIf="collection?.products && collection.products.length != 0"
>
  <div class="border-lg-top mx-lg-3">
    <!-- dont delete me I make the border for the grid -->
  </div>
  <div class="row grid gx-1 gx-lg-0">
    <a
      *ngFor="let product of collection.products"
      [routerLink]="['/products/', product.handle]"
      class="col-6 col-lg-4 action px-lg-3 pb-x pt-lg-3 mb-4"
    >
      <app-collection-item [product]="product"></app-collection-item
    ></a>
  </div>
  <div class="border-bottom mx-lg-3">
    <!-- dont delete me I make the border for the grid -->
  </div>
</div>
<div class="container-xl" *ngIf="collection?.body_html">
  <div class="row body-content">
    <div class="col-12 col-lg-8">
      <h4>Made By Fressko</h4>
      <div class="mt-5 less-content" [innerHTML]="collection.body_html"></div>
      <ng-container *ngIf="_moreContent">
        <div
          class="readmore"
          (click)="_show = !_show"
          *ngIf="!_show && _additionalText.length > 10"
        >
          Read More
        </div>
        <div
          class="more-content"
          [hidden]="!_show"
          [innerHTML]="_additionalText"
        ></div>
        <div
          class="readless"
          (click)="_show = !_show"
          *ngIf="_show && _additionalText"
        >
          Read Less
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div [appStoryblok]="_editable" *ngFor="let blok of story?.content?.body">
  <ndc-dynamic
    *ngIf="components"
    [ndcDynamicComponent]="components[blok.component]"
    [ndcDynamicInputs]="blok"
  >
  </ndc-dynamic>
</div>
